import { render, staticRenderFns } from "./SsoProviderInputDialog.vue?vue&type=template&id=65cb9be6"
import script from "./SsoProviderInputDialog.vue?vue&type=script&lang=ts"
export * from "./SsoProviderInputDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports